import i1 from "../assets/i1.png";
import i2 from "../assets/i2.png";
import i3 from "../assets/i3.png";
import i4 from "../assets/i4.png";
import i5 from "../assets/i5.png";
import i6 from "../assets/i6.png";
import i7 from "../assets/i7.png";
import i8 from "../assets/i8.png";
import i9 from "../assets/i9.png";
import i10 from "../assets/i10.png";
import i11 from "../assets/i11.png";
import i12 from "../assets/i12.png";
import i13 from "../assets/i13.png";
import i14 from "../assets/i14.png";
import i15 from "../assets/i15.png";
import i16 from "../assets/i16.png";

export const INTERNSHIP_SYLLABUS_DATA = [
 {
    id: "intern-1",
    title: "Full Stack Web Development Internship",
    image: i1,
  },

  {
    id: "intern-2",
    title: "MERN Stack Development Internship",
    image: i2,
  },

  {
    id: "intern-3",
    title: "Data Science Internship",
    image: i3,
  },

  {
    id: "intern-4",
    title: "Machine Learning Internship",
    image: i4,
  },

  {
    id: "intern-5",
    title: "Power BI Business Analysis Internship",
    image: i5,
  },

  {
    id: "intern-6",
    title: "Prompt Engineering, AI Tools & Automation",
    image: i6,
  },

  {
    id: "intern-7",
    title: "AI Chatbot Development Internship",
    image: i7,
  },

  {
    id: "intern-8",
    title: "React + Node + LLM API Chatbot Creation",
    image: i8,
  },

  {
    id: "intern-9",
    title: "Data Analytics Internship",
    image: i9,
  },

  {
    id: "intern-10",
    title: "UI/UX Design Internship",
    image: i10,
  },

  {
    id: "intern-11",
    title: "API Development Internship (Node / React)",
    image: i11,
  },

  {
    id: "intern-12",
    title: "Git & GitHub Collaboration Internship",
    image: i12,
  },

  {
    id: "intern-13",
    title: "FERN Stack Development Internship",
    image: i13,
  },

  {
    id: "intern-14",
    title: "Java Full Stack Development Internship",
    image: i14,
  },

  {
    id: "intern-15",
    title: "Web Development Using Python",
    image: i15,
  },

  {
    id: "intern-16",
    title: "Deep Learning & NLP Internship",
    image: i16,
  },
];
